// extracted by mini-css-extract-plugin
export default {"NumberSpinner":"NumberSpinner_NumberSpinner__TM6Je","label":"NumberSpinner_label__usfnq","spinner":"NumberSpinner_spinner__cSj9b"};